<template>
    <div class="ur-data-grid__header__cell" :style="thStyle" :class="thClass" @click="onCheckClick">
        <div class="ur-data-grid__header__cell__title" >
            <ur-icon class="ur-checkbox__icon" :class="checkClass" :icon="checkIcon" iconType="picto" tabindex="0" v-if="isHeaderCheck"/>
        </div>
    </div>
</template>


<script>
export default {
    name : 'urDataGridHeaderCheckCell',
    inject : ['gridInfo'],
    props : {
        rowspan:{type:Number} // It allows rowspan only
    },
    computed : {
        _rowspan() {return parseInt(this.rowspan)||1},
        isHeaderCheck() {
            return this.gridInfo.opts.multiSelect && this.gridInfo.opts.selectCheck;
        },
        status() {
            // 1. get var
            var len = this.gridInfo.vars_viewSize,
                sel = this.gridInfo.vars_selLen;
            // 2. calc var
            if( sel && sel === len ) return 'A';
            if( sel > 0 ) return 'I';
            return 'N'; // default & exception case
        },
        checkClass() {
            if(this.status === 'A' || this.status === 'I') {
                return 'ur-checkbox__checked';
            } else {
                return 'ur-checkbox__unchecked'
            }
        },
        checkIcon() {
            switch(this.status) {
            case 'A': return 'checked';
            case 'I': return 'indeterminate';
            case 'N': return 'box';
            default : return 'box';
            }
        },
        // [COMPUTED] Th cell 안에 보여질 타이틀
        thStyle() {
            let style = {};
            // 1. [필수] Height
            var h = this.gridInfo.opts.headerHeight;
            style['height']        = `${ h* this._rowspan}px`;
            style['margin-bottom'] = `${-h*(this._rowspan-1)}px`;
            style['flex'] = '0 0 '+this.gridInfo.opts.selectCheckboxWidth+'px';
            style['min-width'] = '0px'
            return style;
        },
        thClass() {return 'ur-data-grid__header__cell--checkbox';}
    },
    methods: {
        onCheckClick(e) {
            if(!this.isHeaderCheck) {return;}
            if(this.status === 'A') {
                this.gridInfo.func.resetSelect();
            } else {
                this.gridInfo.func.selectAll();
            }
            this.gridInfo.func.fireEvent('check-click', this.gridInfo.sels, e);
        }
    }
}

</script>
